export default "__VITE_ASSET__A3lJ0rgD__"